import Vue from 'vue'
import Vuex from 'vuex'

// MODULES
import user from './modules/user'
import armory from './modules/armory'

Vue.use(Vuex)

// initial state is stored so we can reset it on logout
let initState = {
  applicationVersion: 0.1,
  user: { ...user.state },
  armory: { ...armory.state }
}

// THE STORE
export const store = new Vuex.Store({
  state: {
    applicationVersion: 0.1
  },
  modules: {
    user,
    armory
  },
  mutations: {
    fullReset (state) {
      Object.keys(state).forEach(key => {
        Object.assign(state[key], initState[key])
      })
    }
  }
})
